//export const apiBaseUrl = 'https://yangguangyimai.cap.test.sankuai.com/'
//export const websocketUrl = 'wss://yangguangyimai.cap.test.sankuai.com/wss'
// export const apiBaseUrl = 'http://www.sk.com/'
// export const websocketUrl = 'ws://www.sk.com/wss'

// export const apiBaseUrl = 'https://yggy.sankuai.com/'
// export const websocketUrl = 'wss://yggy.sankuai.com/wss'

export const apiBaseUrl = "https://mt.zichenweiwu.com/";
export const websocketUrl = "wss://mt.zichenweiwu.com/wss";


/*
st环境
export const apiBaseUrl = 'https://yggy.cap.st.sankuai.com/'
export const websocketUrl = 'wss://yggy.cap.st.sankuai.com/wss'
*/
export const locationHost =
  process.env.NODE_ENV === "production" ? apiBaseUrl : "http://localhost:8080";

// export const apiBaseUrl = 'http://10.189.184.92/';
// export const apiBaseUrl = 'http://sankuai.zichenweiwu.com/'

//export const kfUrl = 'https://km.sankuai.com/collabpage/2440949528?kmId=2440949528&linkType=KM'
export const kfUrl = "https://applink.neixin.cn/chat?pubid=139088494136";

export const pointDescUrl = "https://km.sankuai.com/page/1307816188";

export const autoOfferProtocolUrl =
  "https://km.sankuai.com/collabpage/2749261854"; //自动出价说明

export const isTestLogin = true; //true测试环境 false生产环境
